"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeOpexToastReducer = exports.openOpexToastReducer = exports.updateOpexErrorReducer = exports.updateOpexSuccessReducer = exports.startUpdateOpexReducer = exports.saveOpexErrorReducer = exports.saveOpexSuccessReducer = exports.startSaveOpexReducer = exports.getOpexsErrorReducer = exports.getOpexsSuccessReducer = exports.getOpexsReducer = exports.opexsSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const initialState = {
    areOpexsLoading: false,
    hasErrorLoadingOpexs: false,
    opexs: [],
    isSavingOpex: false,
    saveOpexErrorMessage: "",
    saveOpexSuccessMessage: "",
    isUpdatingOpex: false,
    hasErrorUpdatingOpex: false,
    opexToastStatus: { isOpen: false, message: "", status: undefined },
};
exports.opexsSlice = (0, toolkit_1.createSlice)({
    name: "opexs",
    initialState,
    reducers: {
        getOpexsReducer: (state) => {
            state.areOpexsLoading = true;
        },
        getOpexsSuccessReducer: (state, action) => {
            state.opexs = action.payload;
            state.areOpexsLoading = false;
            state.hasErrorLoadingOpexs = false;
        },
        getOpexsErrorReducer: (state) => {
            state.areOpexsLoading = false;
            state.hasErrorLoadingOpexs = true;
        },
        startSaveOpexReducer: (state) => {
            state.isSavingOpex = true;
            state.saveOpexSuccessMessage = "";
            state.saveOpexErrorMessage = "";
        },
        saveOpexSuccessReducer: (state) => {
            state.isSavingOpex = false;
            state.saveOpexSuccessMessage = "System saved successfully";
        },
        saveOpexErrorReducer: (state) => {
            state.isSavingOpex = false;
            state.saveOpexErrorMessage = "Error creating System";
        },
        startUpdateOpexReducer: (state) => {
            state.isUpdatingOpex = true;
            state.hasErrorUpdatingOpex = false;
        },
        updateOpexSuccessReducer: (state) => {
            state.isUpdatingOpex = false;
            state.hasErrorUpdatingOpex = false;
        },
        updateOpexErrorReducer: (state) => {
            state.isUpdatingOpex = false;
            state.hasErrorUpdatingOpex = true;
        },
        openOpexToastReducer: (state, action) => {
            state.opexToastStatus.status = action.payload.status;
            state.opexToastStatus.message = action.payload.message;
            state.opexToastStatus.isOpen = true;
        },
        closeOpexToastReducer: (state) => {
            state.opexToastStatus.isOpen = false;
            state.opexToastStatus.status = undefined;
            state.opexToastStatus.message = "";
        },
    },
});
_a = exports.opexsSlice.actions, exports.getOpexsReducer = _a.getOpexsReducer, exports.getOpexsSuccessReducer = _a.getOpexsSuccessReducer, exports.getOpexsErrorReducer = _a.getOpexsErrorReducer, exports.startSaveOpexReducer = _a.startSaveOpexReducer, exports.saveOpexSuccessReducer = _a.saveOpexSuccessReducer, exports.saveOpexErrorReducer = _a.saveOpexErrorReducer, exports.startUpdateOpexReducer = _a.startUpdateOpexReducer, exports.updateOpexSuccessReducer = _a.updateOpexSuccessReducer, exports.updateOpexErrorReducer = _a.updateOpexErrorReducer, exports.openOpexToastReducer = _a.openOpexToastReducer, exports.closeOpexToastReducer = _a.closeOpexToastReducer;
exports.default = exports.opexsSlice.reducer;
